/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeviceWithDeploymentDto } from './deviceWithDeploymentDto';


export interface ActivityRequestDto { 
    orderBy?: string;
    orderDirection?: string;
    afterUTC?: string;
    beforeUTC?: string;
    afterSCTS?: string;
    beforeSCTS?: string;
    originCodes?: Array<ActivityRequestDto.OriginCodesEnum>;
    deviceIds?: Array<number>;
    animalIds?: Array<number>;
    devicesWithDeployments?: Array<DeviceWithDeploymentDto>;
    page?: number;
    count?: number;
    lastX?: number;
    gtId?: number;
    columnKeywordsList?: Array<string>;
    extendedMessageTypes?: Array<ActivityRequestDto.ExtendedMessageTypesEnum>;
    sensorIDCodes?: Array<number>;
    deployedOnly?: boolean;
    modeCodes?: Array<ActivityRequestDto.ModeCodesEnum>;
}
export namespace ActivityRequestDto {
    export const OriginCodesEnum = {
        Globalstar: 'GLOBALSTAR',
        Iridium: 'IRIDIUM',
        GsmSms: 'GSM_SMS',
        GsmFtp: 'GSM_FTP',
        Terminal: 'TERMINAL',
        Collar: 'COLLAR',
        NbIot: 'NB_IOT',
        IridiumEmail: 'IRIDIUM_EMAIL'
    } as const;
    export type OriginCodesEnum = typeof OriginCodesEnum[keyof typeof OriginCodesEnum];
    export const ExtendedMessageTypesEnum = {
        NoContact: 'NO_CONTACT',
        Mortality: 'MORTALITY',
        Status: 'STATUS',
        Null: 'NULL',
        Expelled: 'EXPELLED'
    } as const;
    export type ExtendedMessageTypesEnum = typeof ExtendedMessageTypesEnum[keyof typeof ExtendedMessageTypesEnum];
    export const ModeCodesEnum = {
        NoActivityAvailable: 'NO_ACTIVITY_AVAILABLE',
        ActivityMeasurement300S: 'ACTIVITY_MEASUREMENT_300S',
        ActivityMeasurement152S: 'ACTIVITY_MEASUREMENT_152S',
        ActivityMeasurement64: 'ACTIVITY_MEASUREMENT_64',
        ActivityMeasurement: 'ACTIVITY_MEASUREMENT',
        HeadAngleAccelerationThreshold: 'HEAD_ANGLE_ACCELERATION_THRESHOLD',
        AccelerationPeakThreshold: 'ACCELERATION_PEAK_THRESHOLD',
        AvgFortBackUpDownRawData: 'AVG_FORT_BACK_UP_DOWN_RAW_DATA',
        TestModeA: 'TEST_MODE_A',
        TestModeB: 'TEST_MODE_B',
        TestModeC: 'TEST_MODE_C'
    } as const;
    export type ModeCodesEnum = typeof ModeCodesEnum[keyof typeof ModeCodesEnum];
}


export type OriginCodesEnum = typeof ActivityRequestDto.OriginCodesEnum[keyof typeof ActivityRequestDto.OriginCodesEnum];
export type ExtendedMessageTypesEnum = typeof ActivityRequestDto.ExtendedMessageTypesEnum[keyof typeof ActivityRequestDto.ExtendedMessageTypesEnum];
export type ModeCodesEnum = typeof ActivityRequestDto.ModeCodesEnum[keyof typeof ActivityRequestDto.ModeCodesEnum];
